import _ from 'lodash';
import React from 'react';
import Select from 'react-select';

import {
  FormField,
  HelpBlock,
  Label,
  Row,
  selectorProps,
} from './form';

export default function withNameSelect(
  objectName,
  name,
  store,
  label,
  isMulti = false,
  selectAllOption,
  isDisabled = false,
) {
  const kebab = _.kebabCase(name);
  const capitalize = _.capitalize(name);
  const snake = _.snakeCase(name);

  function PlainSelect() {
    const set = store(state => state.set);
    const value = store(state => state[objectName][name]);

    const options = store(state => state[`${name}Options`]);
    let allOptions = options;
    if (selectAllOption) {
      allOptions = _.concat(selectAllOption, options);
    }
    const selectedOption = isMulti
      ? _.map(value, v => _.find(allOptions, { value: v }))
      : _.find(allOptions, { value });

    const errors = store(state => state.errors);

    const handleChange = selected => {
      if (isMulti) {
        if (selectAllOption && _.find(selected, selectAllOption)) {
          set(state => {
            state[objectName][name] = [selectAllOption.value];
          });
        } else {
          set(state => {
            state[objectName][name] = _.map(selected, 'value');
          });
        }
      } else {
        set(state => {
          state[objectName][name] = selected.value;
        });
      }
    };

    return (
      <Row>
        <Label htmlFor={kebab}>{label || name}</Label>
        <FormField>
          <Select
            {...selectorProps}
            isMulti={isMulti}
            isDisabled={isDisabled}
            className={kebab}
            value={selectedOption}
            options={allOptions}
            placeholder={label || capitalize}
            onChange={handleChange}
          />
          {!!errors[snake] && <HelpBlock>{errors[snake]}</HelpBlock>}
        </FormField>
      </Row>
    );
  }

  PlainSelect.displayName = capitalize;

  return PlainSelect;
}
